import { ThemeOptions } from '@mui/material';

/**
 * v2 전용 테마 오버라이드 (프로토타입 index.html 기반).
 *
 * 사용법: GenericLayoutV2에서 root 테마 위에 병합한다.
 *   <ThemeProvider theme={(outer) => createTheme(outer, v2ThemeOptions)}>
 *
 * 중요:
 * 1) inbody 베이스(커스텀 브레이크포인트 mobile/tablet/laptop, components)는 root에서 상속.
 *    제거하면 헤더의 useResponsive가 깨진다.
 * 2) text/background/divider는 덮지 않는다 — root의 모드별(라이트/다크) 팔레트를 그대로 써야
 *    다크모드가 정상 동작한다. 여기서는 브랜드 색(primary)과 폰트만 v2 값으로 덮는다.
 */
export const v2ThemeOptions: ThemeOptions = {
  palette: {
    // --navy / --red : 버건디 브랜드 (라이트/다크 공통)
    primary: {
      main: '#971B2F',
      dark: '#7A1626',
      light: '#F3D9DE', // --ice
      contrastText: '#FFFFFF',
    },
    success: { main: '#16A34A' }, // --green
    warning: { main: '#D97706' }, // --amber
    info: { main: '#2563EB' }, // --blue
  },
  typography: {
    // 프로토타입 기본 폰트/사이즈
    fontFamily: '"맑은 고딕","Malgun Gothic",system-ui,sans-serif',
    fontSize: 14,
  },
};
